import React, { useContext, useEffect } from "react";

import useTranslation from "next-translate/useTranslation";
import Image from "next/image";

import { Button } from "@shopify/polaris";

import Title from "../../components/Title";

import { checkUsableCookie } from "../../../../../../helpers/cookie/checkUsableCookie";
import {
  DISCORD_INVITE_LINK,
  COOKIE_ANALYTICS,
  COOKIE_FUNCTIONALITY,
} from "../../../../../../utils/constants";

import { COOKIE_CONTEXT } from "../../../../../providers/CookieProvider";

import styles from "../../../../Home/CTA/styles.module.scss";
import stylesCTA from "./styles.module.scss";

import discordIcon from "/public/discord/discord.svg";
import phoneIcon from "/public/discord/email/phone.svg";
import letterIcon from "/public/discord/email/letter.svg";

const Index = ({ namespace, bgColor = "#F6F6F7" }) => {
  const { t } = useTranslation(namespace);

  const { openBanner, openCookieToast, isBannerOpen } =
    useContext(COOKIE_CONTEXT);

  const bookACall = () => {
    if (!checkUsableCookie([COOKIE_FUNCTIONALITY, COOKIE_ANALYTICS])) {
      if (isBannerOpen) {
        openCookieToast(COOKIE_FUNCTIONALITY);
      }
      openBanner([COOKIE_FUNCTIONALITY, COOKIE_ANALYTICS]);

      return;
    }

    window.__supportBookACall && window.__supportBookACall();
    return false;
  };

  const startChat = () => {
    const targetElement = document.querySelector('[data-is-failure="false"]');
    if (targetElement) {
      targetElement.click();
    }
  };

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const targetElement = document.querySelector('[data-is-failure="false"]');
      if (targetElement) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  const data = [
    {
      title: t("cta._1.title"),
      desc: t("cta._1.desc"),
      image: <Image src={discordIcon} quality={100} alt="Discord" />,
      action: {
        url: DISCORD_INVITE_LINK,
      },
      label: t("cta._1.action"),
    },
    {
      title: t("cta._2.title"),
      desc: t("cta._2.desc"),
      image: <Image src={letterIcon} quality={100} alt="Discord" />,
      action: {
        onClick: startChat,
      },
      label: t("cta._2.action"),
    },
    {
      title: t("cta._3.title"),
      desc: t("cta._3.desc"),
      image: <Image src={phoneIcon} quality={100} alt="Discord" />,
      action: {
        onClick: bookACall,
      },
      label: t("cta._3.action"),
    },
  ];

  return (
    <section style={{ backgroundColor: bgColor }} className={styles["cta"]}>
      <div className={styles["cta__heading"]}>
        <div className={styles["inner"]}>
          <div className={styles["title"]}>
            <Title>{t("cta.heading")}</Title>
          </div>
          <div className={styles["label"]}>
            <div className={styles["text"]}>{t("cta.label")}</div>
          </div>
        </div>
      </div>
      <div className={styles["cta__container"]}>
        <ul className={styles["cta__carts-list"]}>
          {data.map((item, i) => (
            <li
              className={styles["cta__cart"]}
              key={i}
              style={{
                paddingLeft: 30,
                paddingRight: 30,
                backgroundColor: "#ffffff",
              }}
            >
              <div className={"cta__icon-wrapper"}>
                {item.image && item.image}
              </div>
              <div className={"cta__cart-content"}>
                <h4 className={styles["cta__cart-header"]}>{item.title}</h4>
                <p className={styles["cta__cart-subheader"]}>{item.desc}</p>
              </div>
              <footer className={styles["cta__cart-footer"]}>
                <div className={styles["cta__cart-link"]}>
                  <Button external {...(item.action || {})}>
                    <span className={stylesCTA["btn-text"]}>{item.label}</span>
                  </Button>
                </div>
              </footer>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Index;
